module.exports = __webpack_public_path__ + "img/betplus.2f0f4eb.svg";